import s from "../product.module.css";
import StarRating from "../../../../assets/Components/rating/StarRating";
import {Link} from "react-router-dom";
import React from "react";
import ProductSize from "./ProductSize";
import ProductOrder from "./ProductOrder";
import ProductIcons from "./ProductIcons";
import {useSelector} from "react-redux";
import Categories from "../../Categories";


const ProductMain = ({productData, goToReviews, scrollToMyRef,togglePopUp}) => {
    const reviewsCount = useSelector(state => state.setProduct.reviews.length)

    const openReviews = () => {
        goToReviews();
        scrollToMyRef();
    }


    return (<div className={s.productMain}>
            <img src={productData.img} alt=""/>
            <div className={s.productInfo}>
                <h3>{productData.name}</h3>
                <div className={s.productRating}>
                    <div><StarRating/>
                        <p>{reviewsCount} отзывов</p></div>
                    <a onClick={openReviews}>Написать отзыв</a>
                </div>
                <div className={s.productPrice}>
                    <h3>{productData.price} ГРН</h3>
                    {productData.isAvailable ? <span>Есть в наличии</span> : null}
                </div>
                <h5>Производитель: <span>{productData.factory}</span></h5>
                <ProductSize/>
                <ProductOrder  togglePopUp={togglePopUp} data={{
                    id: productData.id,
                    name: productData.name,
                    price: productData.price,
                    img: productData.img
                }}/>
                <ProductIcons/>
            </div>
        </div>
    )
}

export default ProductMain;